import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import configureStore from "./store/store";
import App from "./app"
import "./mobile.css";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

import WebRtcClass_JsSIP from "./utils/webRTC_JsSIP";

export const WebRtcContextJsSIP = React.createContext({});

const store = configureStore();

createRoot(document.getElementById("app")).render(
  <WebRtcContextJsSIP.Provider value={new WebRtcClass_JsSIP()}>
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>
  </WebRtcContextJsSIP.Provider>
);

// serviceWorker.register();
serviceWorkerRegistration.register();
